import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { EUserDivision } from './user.model';
import { IUser } from './user.model';
import { ApiService } from '../shared/services/api.service';
import { filter, map, tap } from 'rxjs/operators';
import { ProjectResponse } from '../shared/projects';
import { isTrue } from '../abstract';

/**
 * TODO: Use this service to get data about current user from components (e.g show/hide album arts)
 * Remove getCurrentUser from SongApiService
 */

const USER_KEY = 'USER_KEY';

@Injectable({
  providedIn: 'root',
})
export class CurrentUserService {
  currentUserInfo$: BehaviorSubject<IUser> = new BehaviorSubject<IUser>(null);
  myLatestPSRProject: BehaviorSubject<ProjectResponse> = new BehaviorSubject<ProjectResponse>(null);
  myLatestMLRProject: BehaviorSubject<ProjectResponse> = new BehaviorSubject<ProjectResponse>(null);
  myLatestMSRProject: BehaviorSubject<ProjectResponse> = new BehaviorSubject<ProjectResponse>(null);
  myLatestMCRProject: BehaviorSubject<ProjectResponse> = new BehaviorSubject<ProjectResponse>(null);

  private isLoadingData$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(@Inject('ApiService') private api: ApiService) {}

  getCurrentUserInfo(): Observable<IUser> {
    const { currentUserInfo$, isLoadingData$, api } = this;

    if (!currentUserInfo$.value && !isLoadingData$.value) {
      isLoadingData$.next(true);
      api
        .get('users/current_user_info')
        .pipe(
          tap((info: IUser) => {
            // info.division = EUserDivision.CLA;
            localStorage.setItem(USER_KEY, `${info.id}`);
            currentUserInfo$.next(info);
            isLoadingData$.next(false);
          })
        )
        .subscribe();
    }

    return currentUserInfo$.pipe(filter(isTrue));
  }

  getCurrentUserDivision(): Observable<EUserDivision | string> {
    return this.getCurrentUserInfo().pipe(map((user: IUser) => user.division));
  }

  isMLRUser(): Observable<boolean> {
    return this.getCurrentUserDivision().pipe(map(userDivision => /MLR/.test(userDivision)));
  }
}
